import { lazy, Suspense } from "react";
import { Routes, Route, Outlet, useLocation } from "react-router-dom";
import { useState } from "react";
import { Avatar } from "primereact/avatar";
import { TabMenu } from "primereact/tabmenu";
import useApp from "hooks/useApp";
import useAuth from "hooks/useAuth";
import { useTranslation } from "react-i18next";
import PageLoading from "components/PageLoading";
import { Button } from "primereact/button";
const UsersViewPage = lazy(() => import("./View"));
const UsersEditPage = lazy(() => import("./Edit"));
export default function User(props) {
  const [userData, setUserData] = useState({});
  const auth = useAuth();
  const app = useApp();
  const { t } = useTranslation();
  const USER_DETAILS = t("USER_DETAILS");
  const location = useLocation();
  let pageIndex = 0;
  const pathName = window.location.pathname || "";
  const pageName = pathName.split("/")[2] || "";
  // if(pageName === 'edit'){
  // 	pageIndex = 1;
  // }
  // else if(pageName === 'changepassword'){
  // 	pageIndex = 2;
  // }
  const [activeIndex, setActiveIndex] = useState(pageIndex);
  const accountMenuItems = [
    {
      label: USER_DETAILS,
      icon: "pi pi-fw pi-user",
      command: () => app.navigate(`/users/view/${userData.id}`),
    },
  ];
  function setData(data) {
    setUserData(data);
  }
  return (
    <section className="page-section ">
      <div className="container" style={{ minHeight: "100px" }}>
        <div className="surface-200 card  p-0 mb-4">
          <div className="p-4 mb-4">
            <div className="grid align-items-center">
              <div className="col-fixed">
                <Button
                  onClick={() => app.navigate(-1)}
                  label=""
                  className="p-button p-button-text "
                  icon="pi pi-arrow-left"
                />
              </div>
              <div className="col-fixed">
                <Avatar icon="pi pi-user" size="xlarge" shape="circle" />
              </div>
              <div className="col">
                <div className="text-2xl capitalize font-bold text-primary">
                  {" "}
                  {userData?.user}{" "}
                </div>
                <div className="text-500"> {userData?.email} </div>
              </div>
            </div>
          </div>
        </div>
        <div className="card p-0 ">
          <TabMenu
            model={accountMenuItems}
            activeIndex={activeIndex}
            onTabChange={(e) => setActiveIndex(e.index)}
          />
          <div className="p-3">
            <Suspense fallback={<PageLoading />}>
              <Outlet />
              <Routes>
                <Route
                  path="/"
                  element={
                    <UsersViewPage
                      setData={setData}
                      isSubPage
                      organisations={props.organisations}
                      roles={props.roles}
                      accountStatus={props.accountStatus}
                      modules={props.modules}
                    />
                  }
                />
                {/* <Route
                  path="/users/edit/:pageid"
                  element={
                    <UsersEditPage
                      id={userData.id}
                      isSubPage
                      organisations={props.organisations}
                      roles={props.roles}
                      accountStatus={props.accountStatus}
                      modules={props.modules}
                    />
                  }
                /> */}
              </Routes>
            </Suspense>
          </div>
        </div>
      </div>
    </section>
  );
}
